
















































import { Vue, Component, Watch, PropSync } from 'vue-property-decorator';
import { getRange } from '@/libs/time';
import SubjectServices, { SubjectDto, SubjectItemDto } from '@/services/subject';
import { DataItem } from '@/services/analyzeCustom';
import PreviewTable from './preview-table.vue';
@Component({
  components: { PreviewTable }
})
export default class AddCustomTable extends Vue {
  @PropSync('dataItem') syncDataItem!: DataItem;

  subjectSrv = new SubjectServices();
  date: string[] = getRange('week');
  sub: string = '';
  field: string = '';
  visible: boolean = false;

  created() {
    this.getSubList();
    this.onDateChange();
  }

  @Watch('syncDataItem')
  onSyncDataItemChange() {
    // 编辑操作时返填数据
    if (this.subList.length === 0) {
      setTimeout(() => this.onSyncDataItemChange(), 100);
      return false;
    }
    if (!this.syncDataItem?.subCode) return false;
    this.sub = this.syncDataItem.subCode || '';
    this.setListData();
  }

  setListData() {
    if (this.fieldType2List.length === 0 && this.fieldType1List.length === 0) {
      setTimeout(() => this.setListData(), 100);
      return false;
    }
    this.fieldType1Checked = this.syncDataItem.dimensionList.map((v: any) => v.fieldCode);
    this.fieldType2Checked = this.syncDataItem.measureList.map((v: any) => v.fieldCode);
  }

  @Watch('date')
  onDateChange() {
    let [startTime, endTime] = this.date;
    this.syncDataItem.startTime = startTime;
    this.syncDataItem.endTime = endTime;
  }

  subList: SubjectDto[] = [];
  async getSubList() {
    this.subList = await this.subjectSrv.getEnableList();
  }

  subFieldList: SubjectItemDto[] = [];
  @Watch('sub')
  async getSubField() {
    this.subFieldList = await this.subjectSrv.getFieldList({ subCode_eq: this.sub });
    console.log(this.subFieldList);
    this.syncDataItem.subCode = this.sub;
  }

  // 数据期
  get fieldType0List() {
    return this.subFieldList.filter((v: SubjectItemDto) => v.fieldCategory === '0');
  }
  // 维度值
  fieldType1Checked: string[] = [];
  get fieldType1List() {
    return this.subFieldList.filter((v: SubjectItemDto) => v.fieldCategory === '1').map((f: SubjectItemDto) => ({ ...f, title: f.fieldName, key: f.fieldCode }));
  }
  @Watch('fieldType1Checked')
  onFieldType1CheckedChange() {
    this.syncDataItem.dimensionList = [];
    this.fieldType1List.forEach((v: any) => {
      if (this.fieldType1Checked.includes(v.fieldCode)) this.syncDataItem.dimensionList.push(v);
    });
  }
  // 度量值
  fieldType2Checked: string[] = [];
  get fieldType2List() {
    return this.subFieldList.filter((v: SubjectItemDto) => v.fieldCategory === '2').map((f: SubjectItemDto) => ({ ...f, title: f.fieldName, key: f.fieldCode }));
  }
  @Watch('fieldType2Checked')
  onFieldType2CheckedChange() {
    this.syncDataItem.measureList = [];
    this.fieldType2List.forEach((v: any) => {
      if (this.fieldType2Checked.includes(v.fieldCode)) this.syncDataItem.measureList.push(v);
    });
  }

  preview() {
    if (!this.syncDataItem?.subCode || !this.syncDataItem?.dataField || !this.syncDataItem?.measureList) {
      this.$message.error('请将数据明细表单补充完整');
      return false;
    }
    this.visible = true;
  }

  onDrop(e: any) {
    const dropKey = e.node.eventKey;
    const dragKey = e.dragNode.eventKey;
    const dropPos = e.node.pos.split('-');
    const dropPosition = e.dropPosition - Number(dropPos[dropPos.length - 1]);
    let list = this.subFieldList;
    let dropIndex = list.findIndex(v => v.fieldCode === dropKey);
    let index = list.findIndex(v => v.fieldCode === dragKey);
    if (index > dropIndex) {
      if (dropPosition === 1) {
        list.splice(dropIndex + 1, 0, list[index]);
      } else {
        list.splice(dropIndex, 0, list[index]);
      }
      list.splice(index + 1, 1);
    } else {
      if (dropPosition === -1) {
        list.splice(dropIndex, 0, list[index]);
      } else {
        list.splice(dropIndex + 1, 0, list[index]);
      }
      list.splice(index, 1);
    }
  }
}
